import { ACTIONS_SITE } from '../_constants/site.constants';

const initialState = {
  byId: {},
};

export function siteReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_SITE.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_SITE.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_SITE.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default siteReducer;
